import { useRef, useState } from 'react';
import { Col, Row, Typography } from 'antd';
import moment, { Moment } from 'moment';
import { ProjectDto } from '@/core';
import { DATE_LOCAL_FORMAT } from '@/platform';
import { useUserContextSelector } from '@/redux';
import DistributionChart from './charts/DistributionChart';
import ProductsChart from './charts/ProductsChart';
import TotalChart from './charts/TotalChart';
import { ReportsStatisticDateFilters } from './ReportsStatisticDateFilters';
import { ReportsStatistic } from './ReportsStatistic';
import { setJanuaryCurrentYear } from './hooks/useStatisticPeriodsOptions';
import { ButtonDownloadStatisticPdf } from './ButtonDownloadStatisticPdf';

type ReportsStatisticTabPropsType = {
  projectData: ProjectDto;
};

const formatDateForRequest = (date: Moment | null) => date?.format(DATE_LOCAL_FORMAT);

export const ReportsStatisticTab = ({ projectData }: ReportsStatisticTabPropsType) => {
  const [startDate, setStartDate] = useState<Moment | null>(setJanuaryCurrentYear());
  const [endDate, setEndDate] = useState<Moment | null>(moment());
  const [costTypesLegends, setCostTypesLegends] = useState<string[]>([]);
  const [name] = useUserContextSelector((x) => [x.name]);
  const formattedStartDate = formatDateForRequest(startDate);
  const formattedEndDate = formatDateForRequest(endDate);
  const pdfRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Row justify="space-between">
        <Typography.Title className="mb-4" level={3}>
          {name.split(' ')?.[0]}, this is your project overview
        </Typography.Title>
        <ButtonDownloadStatisticPdf pdfRef={pdfRef} />
      </Row>
      <div ref={pdfRef}>
        <ReportsStatisticDateFilters
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
        <ReportsStatistic
          startDate={formattedStartDate}
          endDate={formattedEndDate}
          costTypesLegends={costTypesLegends}
          projectData={projectData}
        />
        <Row gutter={[32, 32]}>
          <Col xs={24} xl={12}>
            <TotalChart projectData={projectData} startDate={startDate} endDate={endDate} />
          </Col>
          <Col xs={24} xl={12}>
            <DistributionChart
              startDate={formattedStartDate}
              endDate={formattedEndDate}
              setCostTypesLegends={setCostTypesLegends}
            />
          </Col>
          <Col span={24}>
            <ProductsChart startDate={formattedStartDate} endDate={formattedEndDate} />
          </Col>
        </Row>
      </div>
    </>
  );
};
